/**
 * Storage key for Vue component logger in localStorage
 */
export const STORAGE_KEY = 'vue_component_logger'

/**
 * Logger configuration object
 */
export const LoggerConfig = {
    /**
     * Manual disable flag for logging
     * @type {boolean}
     */
    disableLog: true,

    /**
     * Check if logging is enabled
     * Logging is enabled only on localhost or dev environments
     * @returns {boolean}
     */
    enabled() {
        if (this.disableLog) return false

        const host = window.location.hostname
        return host === 'localhost' || host.includes('dev')
    },

    /**
     * Maximum number of log entries to store
     * @type {number}
     */
    maxEntries: 500,

    /**
     * Whether to show logs in console immediately
     * @type {boolean}
     */
    showInConsole: false,

    /**
     * Log all components regardless of logComponents list
     * @type {boolean}
     */
    logAllComponents: true,

    /**
     * List of specific components to log (when logAllComponents is false)
     * @type {string[]}
     */
    logComponents: [
        'StepNavigstion.vue',
        // 'imprintAppSummary.vue'
    ],
}
